<template>
  <div>
    <tabWallets></tabWallets>
  </div>
</template>


<script>
import tabWallets from "./tabWallets"
export default {
  name: "walletMain",
  components: {
    tabWallets
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/profileDashboard/vendor/wallet/walletMain.vue